import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block bg-primary relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="h-full w-full object-cover opacity-70" />
        <div className="absolute bottom-12 left-12 text-primary-foreground">
          <div className="font-display text-4xl font-extrabold tracking-tighter">RUBINO<span className="font-light"> Real Estate</span></div>
          <div className="overline text-primary-foreground/60 mt-2">Advisor Dashboard</div>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-20">
        <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm">
          <Link to="/" className="overline text-muted-foreground link-underline">← Back to site</Link>
          <h1 className="font-display text-4xl font-extrabold tracking-tighter mt-8 mb-2">Sign in</h1>
          <p className="text-sm text-muted-foreground mb-10">Restricted access for Rubino Real Estate advisors.</p>

          <div className="space-y-6">
            <div>
              <label className="overline text-muted-foreground">Email</label>
              <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="rounded-none border-0 border-b border-border bg-transparent px-0 h-12 focus-visible:ring-0 focus-visible:border-foreground mt-2" />
            </div>
            <div>
              <label className="overline text-muted-foreground">Password</label>
              <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="rounded-none border-0 border-b border-border bg-transparent px-0 h-12 focus-visible:ring-0 focus-visible:border-foreground mt-2" />
            </div>
          </div>

          {error && <p data-testid="login-error" className="text-destructive text-sm mt-4">{error}</p>}

          <button data-testid="login-submit" disabled={loading}
            className="mt-10 w-full border border-foreground py-4 overline hover-invert hover:bg-foreground hover:text-background disabled:opacity-50">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
